export enum DispatchSearchType {
  all = 1,
  service = 2,
  construction = 3
}
